import { useCallback } from 'react';

import styles from './style.module.css';

// A labelled multi-line field with an optional error, for text longer than
// a line. It hands its parent the value rather than the event, as TextField
// does, and links the error with aria-describedby.
export function TextArea({ ref, id, label, value, onChange, onBlur, error, rows = 3 }) {
  const onInput = useCallback(function({ currentTarget }) {
    onChange(currentTarget.value);
  }, [ onChange ]);

  let note = null;
  let describedBy = null;

  if (typeof error === 'string') {
    note = <span id={ `${ id }-error` } className={ styles.error } role='alert'>{ error }</span>;
    describedBy = `${ id }-error`;
  }

  return (
    <div className={ styles.field }>
      <label className={ styles.label } htmlFor={ id }>{ label }</label>

      <textarea
        ref={ ref }
        id={ id }
        className={ styles.input }
        rows={ rows }
        value={ value }
        onChange={ onInput }
        onBlur={ onBlur }
        aria-invalid={ typeof error === 'string' }
        aria-describedby={ describedBy }
      />

      { note }
    </div>
  );
}
